export var makeDividerStyles = function makeDividerStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiDivider: {
      defaultProps: {
        light: true
      },
      styleOverrides: {
        root: {
          borderColor: tokens.colors["divider-1"]
        },
        light: {
          borderColor: tokens.colors["divider-0"]
        }
      }
    }
  };
};